import React, { createContext, useReducer, useContext } from "react";
import {
  defaultChannelId,
  defaultRegionIndex,
  defaultQualityIndex,
} from "./constants";

const defaultPlayerContext = {
  visible: false,
  currentUrl: { url: null, channelId: null, regionIndex: null },
  readyUrl: null,
  playerRef: null,
  userIntent: false,
  meta: { channelId: null, title: null },
};
export const ChannelContext = createContext(defaultChannelId);
export const RegionContext = createContext(defaultRegionIndex);
export const QualityContext = createContext(defaultQualityIndex);
export const PlayerContext = createContext(defaultPlayerContext);

const PlayerReducer = (state, action) => {
  switch (action.type) {
    case "SHOW":
      return { ...state, visible: true };
    case "HIDE":
      return { ...state, visible: false };
    case "PLAY_READY_URL":
      return {
        ...state,
        currentUrl: state.readyUrl,
      };
    case "SET_CURRENT_URL":
      return {
        ...state,
        currentUrl: action.currentUrl,
      };
    case "SET_READY_URL":
      return { ...state, readyUrl: action.url };
    case "SET_PLAYER_REF":
      return { ...state, playerRef: action.ref };
    case "SET_USER_INTENT":
      return { ...state, userIntent: true };
    case "SET_META":
      return { ...state, meta: action.meta };
    default:
      return state;
  }
};

export const PlayerProvider = ({ children }) => {
  const [state, dispatch] = useReducer(PlayerReducer, defaultPlayerContext);
  const setUserIntent = () => dispatch({ type: "SET_USER_INTENT" });
  const showPlayer = () => dispatch({ type: "SHOW" });
  const hidePlayer = () => dispatch({ type: "HIDE" });
  const playReadyUrl = () => dispatch({ type: "PLAY_READY_URL" });
  const setReadyUrl = (url) => dispatch({ type: "SET_READY_URL", url });
  const setPlayerRef = (ref) => dispatch({ type: "SET_PLAYER_REF", ref });
  const setMeta = (meta) => dispatch({ type: "SET_META", meta });
  const setCurrentUrl = (currentUrl) =>
    dispatch({ type: "SET_CURRENT_URL", currentUrl });

  return (
    <PlayerContext.Provider
      value={{
        ...state,
        showPlayer,
        hidePlayer,
        playReadyUrl,
        setReadyUrl,
        setPlayerRef,
        setUserIntent,
        setMeta,
        setCurrentUrl,
      }}
    >
      {children}
    </PlayerContext.Provider>
  );
};
